// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Stats_wrap__1QxN4","title":"Stats_title__14DSj","item":"Stats_item__quScG","counter":"Stats_counter__1-2ql"};